import { Navigate, Route, Routes } from "react-router";

import { ProtectedRoute } from "@/components/protected-route";
import { HomePage } from "@/features/home";
import { LoginPage } from "@/features/login";
import { NotFoundPage } from "@/features/not-found";
import { ProfilePage } from "@/features/profile";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/home" element={<HomePage />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
